module.exports = __webpack_public_path__ + "img/pic_162914_3.0ec03fe6.jpg";